<div class="ai-container position-absolute start-0 top-0 pe-none">
  <div class="ai-wrapper w-100 h-100 position-relative">
    <div id="draggableCard"
          class="card position-absolute rounded-4 pe-auto"
          [ngClass]="fullscreen ? 'shadow-lg fullscreen' : 'shadow'"
          [ngStyle]="{
                  width: fullscreen ? '90%' : minimized ? '13rem' : '40rem',
                  height: fullscreen ? '85%' : '',
                  top: fullscreen ? '50%': '',
                  bottom: fullscreen ? '' : '0',
                  left: '50%',
                  transform: fullscreen ? 'translate(-50%, -50%)' : 'translateX(-50%)',
                }">

      <div id="dragHandle" class="popup-header d-flex align-items-center justify-content-end px-3 pb-2 pt-3 rounded-top-4" style="cursor: grab; user-select: none;">
        <div class="d-flex align-items-center">
          <button type="button" class="icon-circle me-2" aria-label="Fullscreen" (click)="fullscreenEditor()">
            <i *ngIf="!fullscreen" class="material-icons">fullscreen</i>
            <i *ngIf="fullscreen" class="material-icons">close_fullscreen</i>
          </button>
          <button type="button" class="icon-circle me-2" aria-label="Minimize" (click)="minimizeEditor()">
            <i *ngIf="!minimized" class="material-icons">remove</i>
            <i *ngIf="minimized" class="material-icons">height</i>
          </button>
          <button type="button" class="icon-circle" aria-label="Close" (click)="closeEditor()">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>

      <div *ngIf="!minimized && !fullscreen" class="card-body rounded-bottom-4 px-3 pb-2 py-1 d-flex flex-column justify-content-end" style="min-height: 200px">
        <div class="d-flex flex-column justify-content-end overflow-hidden" style="max-height: 270px">
          <div *ngFor="let message of messages; let last = last" class="d-flex flex-shrink-0 border rounded-4 ai-message mt-2"
               style="min-height: 60px; animation: slideUp 5s linear;">
            <div class="px-3 pt-2">
              <div *ngIf="message.role == 'assistant'" class="position-relative d-flex align-items-end" style="width: 20px; height: 30px">
                <img src="assets/images/ai-icon.svg" style="width: 20px">
                <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
              </div>
              <div
                *ngIf="message.role == 'user'"
                class="rounded-circle avatar-xxs mt-1"
                [ngStyle]="{'background': getLogoBackground()}"
              >
                <img
                  [src]="app_icon"
                  class="rounded-4 img-fluid object-fit-fill"
                  alt=""
                  height="50"
                  onerror="this.onerror=null; this.src='assets/images/users/logo.webp'"
                />
              </div>
            </div>
            <div class="pt-3">
              <span *ngIf="message.role == 'user'" class="message-text mt-2 mb-1" [innerHTML]="message?.content"></span>
              <!-- Typing animation for the last assistant message -->
              <markdown *ngIf="message.role == 'assistant' && last" class="message-text mb-1 mt-2" [data]="displayedMessage"></markdown>

              <!-- Fully loaded message for non-last assistant messages -->
              <markdown *ngIf="message.role == 'assistant' && !last" class="message-text mb-1 mt-2" [data]="message?.content"></markdown>
            </div>
          </div>
          <div *ngIf="loadingMessage && !isProcessingQueue" class="d-flex flex-shrink-0 border rounded-4 ai-message mt-2" style="min-height: 60px; animation: slideUp 5s linear;">
            <div class="d-flex px-3 pt-2">
              <div class="position-relative d-flex align-items-end" style="height: 30px">
                <img src="assets/images/ai-icon.svg" class="big-star" style="width: 20px">
                <img src="assets/images/ai-icon.svg" class="small-star position-absolute" style="width: 10px; top: 4px; right: -6px">
              </div>
              <span *ngIf="thinkingMessage" class="thinking ms-3 mt-2">
                <span class="text">Thinking</span>
                <span class="shimmer-primary"></span>
              </span>
              <div *ngIf="!thinkingMessage" class="typing-indicator ms-3 mt-1">
                <span class="dot dot-1"></span>
                <span class="dot dot-2"></span>
                <span class="dot dot-3"></span>
              </div>
            </div>
          </div>
          <div *ngIf="errorMessage" class="card ai-card rounded-4 chatMessage w-100" style="max-width: 700px" [ngClass]="{'dark': mode == 'dark' }">
            <div class="card-body">
              <div class="d-flex flex-column flex-sm-row">
                <div class="position-relative d-flex align-items-end" style="height: 30px">
                  <img src="assets/images/ai-icon.svg" style="width: 20px">
                  <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
                </div>
                <div class="d-flex flex-column ps-3 message-text">
                  <span class="fw-bold mt-2 mb-1">AI Unavailable</span>
                  <span class="mb-2">The AI has experienced an error please refresh or try again later</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="doneMessage" class="card ai-card rounded-4 chatMessage w-100" style="max-width: 700px" [ngClass]="{'dark': mode == 'dark' }">
            <div class="card-body">
              <div class="d-flex flex-column flex-sm-row">
                <div class="d-flex align-items-center align-items-sm-start justify-content-start">
                  <div class="position-relative d-flex align-items-end" style="width: 20px; height: 30px">
                    <img src="assets/images/ai-icon.svg" style="width: 20px">
                    <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
                  </div>
                  <span class="d-block d-sm-none text-muted font-size-12 mt-2 ms-3">AI Assistant</span>
                </div>
                <div class="d-flex flex-column ps-3 message-text">
                  <span class="fw-bold mt-2 mb-1">You're all set!</span>
                  <span class="mb-2">We've gathered all your custom configurations to build your app just the way you envision it. When you click Generate App, your app will be created with all your settings, and you'll be taken to the full app builder interface where you can:</span>
                  <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">See a Real-Time Preview: </span>Watch as your design and navigation come to life.</span></span>
                  <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Customize Navigation & Layout: </span>Adjust tabs, menus, and overall flow to suit your needs.</span></span>
                  <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Refine Branding & Side Menu: </span>Set your app's identity and add extra native components.</span></span>
                  <span class="mb-2 d-flex align-items-center justify-content-start"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Tweak Settings & Build Details: </span>Fine-tune everything from language and theme to payment and authentication.</span></span>
                  <span class="mb-3">Ready to build your dream app? Click Generate App to get started!</span>
                  <div>
                    <button class="btn w-lg done-button rounded-pill" (click)="generateApp(module, web)">
                      Generate App
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column mt-2">
          <div class="input-wrapper d-flex align-items-center flex-grow-1 rounded-4 mx-1 mt-1">
            <textarea id="inputArea" placeholder="Write your answer" class="rounded-pill w-100 text-wrap font-size-14 my-1" rows="1" [(ngModel)]="inputText" (input)="adjustHeight($event)" [disabled]="doneMessage" (keydown.enter)="submitAnswer()"></textarea>
            <button type="submit" class="send-button" (click)="submitAnswer()" [disabled]="!inputText.trim() || doneMessage || disableInput">
              <span class="material-icons">east</span>
            </button>
          </div>
          <div class="d-flex align-items-center mt-3 ms-1">
            <i class="material-icons font-size-18 me-2">add</i>
            <i class="material-icons font-size-17 me-2 ms-1">thumb_up</i>
            <i class="material-icons font-size-17 ms-1">thumb_down</i>
          </div>
        </div>
      </div>
      <div *ngIf="!minimized && fullscreen" class="card-body rounded-bottom-4 px-2 py-2 d-flex flex-column justify-content-end flex-grow-1 position-relative overflow-hidden">
        <div class="grid-background position-absolute top-0 start-0 w-100 h-100">
          <div
            *ngFor="let h of horizontalLines; let i = index"
            class="h-line"
            [ngStyle]="{ 'top': (i * horizontalSpacing) + '%' }"
          >
            <div class="base-line" [ngClass]="{'initial-animate': startupAnimate, 'horizontal': true}"></div>
            <div
              class="color-segment horiz-gradient"
              [ngStyle]="{
                'animation-delay': delayArray[i] + 's',
                'animation-duration': speedArray[i] + 's'
              }"
              [ngClass]="{'dark': mode == 'dark' }"
            ></div>
          </div>
          <div
            *ngFor="let v of verticalLines; let j = index"
            class="v-line"
            [ngStyle]="{ 'left': (j * verticalSpacing) + '%' }"
          >
            <div class="base-line" [ngClass]="{'initial-animate': startupAnimate, 'vertical': true}"></div>
            <div
              class="color-segment vert-gradient"
              [ngStyle]="{
                'animation-delay': delayArray[j] + 's',
                'animation-duration': speedArray[j] + 's'
              }"
              [ngClass]="{'dark': mode == 'dark' }"
            ></div>
          </div>
        </div>
        <div #messagesContainer class="d-flex flex-column align-items-center flex-grow-1 overflow-auto invisible-scrollbar" style="z-index: 1">
          <div *ngFor="let message of messages; let last = last" class="d-flex flex-shrink-0 border rounded-4 ai-card w-100 mb-2" style="min-height: 60px; max-width: 800px; animation: slideUp 5s linear;">
            <div class="px-3 pt-2">
              <div *ngIf="message.role == 'assistant'" class="position-relative d-flex align-items-end" style="width: 20px; height: 30px">
                <img src="assets/images/ai-icon.svg" style="width: 20px">
                <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
              </div>
              <div
                *ngIf="message.role == 'user'"
                class="rounded-circle avatar-xxs mt-1"
                [ngStyle]="{'background': getLogoBackground()}"
              >
                <img
                  [src]="app_icon"
                  class="rounded-4 img-fluid object-fit-fill"
                  alt=""
                  height="50"
                  onerror="this.onerror=null; this.src='assets/images/users/logo.webp'"
                />
              </div>
            </div>
            <div class="pt-3">
              <span *ngIf="message.role == 'user'" class="message-text mt-2 mb-1" [innerHTML]="message?.content"></span>
              <!-- Typing animation for the last assistant message -->
              <markdown *ngIf="message.role == 'assistant' && last" class="message-text mb-1 mt-2" [data]="displayedMessage"></markdown>

              <!-- Fully loaded message for non-last assistant messages -->
              <markdown *ngIf="message.role == 'assistant' && !last" class="message-text mb-1 mt-2" [data]="message?.content"></markdown>
            </div>
          </div>
          <div *ngIf="loadingMessage && !isProcessingQueue" class="d-flex flex-shrink-0 border rounded-4 ai-card w-100 mb-2" style="min-height: 60px; max-width: 800px; animation: slideUp 5s linear;">
            <div class="d-flex px-3 pt-2">
              <div class="position-relative d-flex align-items-end" style="height: 30px">
                <img src="assets/images/ai-icon.svg" class="big-star" style="width: 20px">
                <img src="assets/images/ai-icon.svg" class="small-star position-absolute" style="width: 10px; top: 4px; right: -6px">
              </div>
              <span *ngIf="thinkingMessage" class="thinking ms-3 mt-2">
                <span class="text">Thinking</span>
                <span class="shimmer"></span>
              </span>
              <div *ngIf="!thinkingMessage" class="typing-indicator ms-3 mt-1">
                <span class="dot dot-1"></span>
                <span class="dot dot-2"></span>
                <span class="dot dot-3"></span>
              </div>
            </div>
          </div>
          <div *ngIf="errorMessage" class="card ai-card border rounded-4 chatMessage w-100" style="max-width: 800px" [ngClass]="{'dark': mode == 'dark' }">
            <div class="card-body  border rounded-4">
              <div class="d-flex flex-column flex-sm-row">
                <div class="position-relative d-flex align-items-end" style="height: 30px">
                  <img src="assets/images/ai-icon.svg" style="width: 20px">
                  <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
                </div>
                <div class="d-flex flex-column ps-3 message-text">
                  <span class="fw-bold mt-2 mb-1">AI Unavailable</span>
                  <span class="mb-2">The AI has experienced an error please refresh or try again later</span>
                </div>
              </div>
            </div>
          </div>




          <div *ngIf="doneMessage" class="card ai-card border rounded-4 chatMessage w-100" style="max-width: 800px" [ngClass]="{'dark': mode == 'dark' }">
            <div class="card-body  border rounded-4">
              <div class="d-flex flex-column flex-sm-row">
                <div class="d-flex align-items-center align-items-sm-start justify-content-start">
                  <div class="position-relative d-flex align-items-end" style="width: 20px; height: 30px">
                    <img src="assets/images/ai-icon.svg" style="width: 20px">
                    <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
                  </div>
                  <span class="d-block d-sm-none text-muted font-size-12 mt-2 ms-3">AI Assistant</span>
                </div>

                <div *ngIf="module =='bot'" >
                  <div *ngIf="web =='generate'">
                    <div class="d-flex flex-column ps-3 message-text">
                      <span class="fw-bold mt-2 mb-1">You're all set!</span>
                      <span class="mb-2">Click Generate to create and launch your bot</span>
                      <div>
                        <button class="btn w-lg  btn-primary rounded-pill" (click)="generateApp(module, web)">
                          Generate
                        </button>
                      </div>
                    </div>
                  </div>


                  <div *ngIf="web=='update'">
                    <div class="d-flex flex-column ps-3 message-text">
                      <span class="fw-bold mt-2 mb-1">You're all set!</span>
                      <span class="mb-2">We've gathered all your custom configurations to build your app just the way you envision it. When you click Generate App, your app will be created with all your settings, and you'll be taken to the full app builder interface where you can:</span>
                      <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">See a Real-Time Preview: </span>Watch as your design and navigation come to life.</span></span>
                      <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Customize Navigation & Layout: </span>Adjust tabs, menus, and overall flow to suit your needs.</span></span>
                      <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Refine Branding & Side Menu: </span>Set your app's identity and add extra native components.</span></span>
                      <span class="mb-2 d-flex align-items-center justify-content-start"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Tweak Settings & Build Details: </span>Fine-tune everything from language and theme to payment and authentication.</span></span>
                      <div>
                        <button class="btn w-lg  btn-primary rounded-pill" (click)="generateApp(module, web)">
                          Generate
                        </button>
                      </div>
                    </div>
                  </div>

                </div>




                <!-- <div class="d-flex flex-column ps-3 message-text">
                  <span class="fw-bold mt-2 mb-1">You're all set!</span>
                  <span class="mb-2">We've gathered all your custom configurations to build your app just the way you envision it. When you click Generate App, your app will be created with all your settings, and you'll be taken to the full app builder interface where you can:</span>
                  <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">See a Real-Time Preview: </span>Watch as your design and navigation come to life.</span></span>
                  <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Customize Navigation & Layout: </span>Adjust tabs, menus, and overall flow to suit your needs.</span></span>
                  <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Refine Branding & Side Menu: </span>Set your app's identity and add extra native components.</span></span>
                  <span class="mb-2 d-flex align-items-center justify-content-start"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Tweak Settings & Build Details: </span>Fine-tune everything from language and theme to payment and authentication.</span></span>
                  <span class="mb-3">Ready to build your dream app? Click Generate App to get started!</span>
                  <div>
                    <button class="btn w-lg  btn-primary rounded-pill" (click)="generateApp()">
                      Generate
                    </button>
                  </div>
                </div> -->

              </div>
            </div>
          </div>




        </div>
        <div class="d-flex flex-column align-items-center mt-2" style="z-index: 1">
          <div class="d-flex align-items-center justify-content-start flex-wrap gap-2 mt-2 mb-1 w-100" style="max-width: 800px">
            <button class="ai-option font-size-12 me-2 order-4 order-sm-1" (click)="help()" [ngClass]="{'dark': mode == 'dark' }" [class.disabled]="doneMessage || disableInput" [disabled]="doneMessage || disableInput">Help me answer</button>
            <button class="ai-option font-size-12 order-2 order-sm-2" (click)="accept()" [ngClass]="{'dark': mode == 'dark' }" [class.disabled]="doneMessage || disableInput" [disabled]="doneMessage || disableInput"><span class="material-icons font-size-13">thumb_up</span></button>
            <button class="ai-option font-size-12 order-3 order-sm-3" (click)="decline()" [ngClass]="{'dark': mode == 'dark' }" [class.disabled]="doneMessage || disableInput" [disabled]="doneMessage || disableInput"><span class="material-icons font-size-13">thumb_down</span></button>
          </div>
          <div class="input-wrapper d-flex align-items-center flex-grow-1 w-100 rounded-4 mx-1 mt-1" style="max-width: 800px">
            <textarea id="inputArea" placeholder="Write your answer" class="rounded-pill w-100 text-wrap font-size-14 my-1" rows="1" [(ngModel)]="inputText" (input)="adjustHeight($event)" [disabled]="doneMessage" (keydown.enter)="submitAnswer()"></textarea>
            <button type="submit" class="send-button" (click)="submitAnswer()" [disabled]="!inputText.trim() || doneMessage || disableInput">
              <span class="material-icons">east</span>
            </button>
          </div>
          <div class="d-flex align-items-center mt-3 ms-1 invisible">
            <i class="material-icons font-size-18 me-2">add</i>
            <i class="material-icons font-size-17 me-2 ms-1">thumb_up</i>
            <i class="material-icons font-size-17 ms-1">thumb_down</i>
          </div>
        </div>
      </div>
      <div *ngIf="minimized && !fullscreen">
        <div class="card-body rounded-bottom-4 px-3 py-2 d-flex flex-column justify-content-end">
          <div class="d-flex align-items-center editor-button ms-0 pe-none rounded-4 w-100">
            <div class="pe-3">
              <div class="position-relative d-flex align-items-end pb-1" style="width: 18px; height: 29px;">
                <img src="assets/images/ai-icon.svg" style="width: 18px; filter: brightness(0) invert(1);">
                <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 2px; right: -6px; filter: brightness(0) invert(1);">
              </div>
            </div>
            <div>
              AI editor
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
